import { combineReducers } from "redux";
import { routerReducer } from "react-router-redux";
import authReducer from "./authReducer";
import searchReducer from "./searchReducer";
import messageReducer from "./messageReducer";
import dashboardReducer from "./dashboardReducer";
import { reducer as formReducer } from "redux-form";

// interface RootStore {
//   routing: Reducer<RouterState, AnyAction>;
//   auth: AuthState;
//   search: SearchState;
//   message: MessageState;
//   dashboard: DashboardState;
//   form: reducer;
// }

const appReducer = combineReducers({
  routing: routerReducer,
  auth: authReducer,
  search: searchReducer,
  message: messageReducer,
  dashboard: dashboardReducer,
  form: formReducer,
});

const rootReducer = (state: any, action: any) => {
  if (action.type === "RESET_ALL_DATA") {
    state = {
      auth: state.auth,
    };
  }
  return appReducer(state, action);
};

export default rootReducer;

export type RootState = ReturnType<typeof appReducer>;
